import { mediaQuery } from '@/styles/media';
import styled from 'styled-components';

const Text = styled.p`
  font-size: 14px;
  color: #666;

  ${mediaQuery.sp} {
    font-size: 13px;
  }
`;

type Props = {
  children: React.ReactNode;
};

const ArticleDate: React.FC<Props> = ({ children }) => <Text>{children}</Text>;

export default ArticleDate;
